var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#085488",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(2.25 .75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.355 7.461H13.144V15.987H0.355z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.75,
    cy: 11.724,
    r: 1.421
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.303 7.46V3.909C10.322 1.966 8.763.375 6.82.355H6.75c-1.942-.02-3.533 1.54-3.553 3.482V7.46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLocked);
export default __webpack_public_path__ + "static/media/blue-locked.0cf8a119944043d0a586994a153e62e2.svg";
export { ForwardRef as ReactComponent };